import type { AppConfig } from './app-config.model';
import { isAppConfig } from './app-config.validator';

/**
 * Loads and validates the runtime configuration (FR-033). Uses bare `fetch`
 * because the injector does not exist yet (research R-014 cross-repo note).
 * Any failure — network error, non-2xx, non-JSON body, failed validation —
 * rejects; no defaults are ever substituted (FR-034).
 */
export async function loadAppConfig(url = '/config.json'): Promise<AppConfig> {
  let response: Response;
  try {
    response = await fetch(url, { cache: 'no-store' });
  } catch (cause) {
    throw new Error(`Failed to fetch ${url}`, { cause });
  }

  if (!response.ok) {
    throw new Error(`Failed to load ${url}: HTTP ${response.status}`);
  }

  let body: unknown;
  try {
    body = await response.json();
  } catch (cause) {
    throw new Error(`Failed to parse ${url} as JSON`, { cause });
  }

  if (!isAppConfig(body)) {
    throw new Error(`Invalid runtime configuration in ${url}`);
  }
  return body;
}
